<template>
  <b-row class="mt-2">
    <b-col
      v-if="innerEditDefaultPickupDateTime"
      cols="12"
      xl="4"
      lg="12"
      md="12"
      sm="12"
      class=""
    >
      <label>Default Pickup Day {{ number }}</label>
      <v-select
        v-model="innerDefaultPickupDay"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :options="pickupDays"
        label="name"
        :clearable="true"
        class="preferences-select"
        :placeholder="`Select Default Pickup Day ${number}`"
        :reduce="d => d.id"
      />
    </b-col>
    <b-col
      v-if="innerEditDefaultPickupDateTime"
      cols="12"
      xl="4"
      lg="12"
      md="12"
      sm="12"
      class=""
    >
      <label>Default Pickup Time {{ number }}</label>
      <v-select
        v-model="innerDefaultPickupTime"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :options="pickupHours"
        :clearable="true"
        class="preferences-select"
        :placeholder="`Select Default Pickup Day ${number}`"
        :reduce="option => option.id"
      >
        <template
          slot="option"
          slot-scope="option"
        >
          {{ option.start_at }} - {{ option.end_at }}
        </template>
        <template
          slot="selected-option"
          slot-scope="option"
        >
          {{ option.start_at }} - {{ option.end_at }}
        </template>
      </v-select>
    </b-col>
    <b-col
      v-if="innerEditDefaultPickupDateTime"
      cols="12"
      xl="4"
      lg="12"
      md="12"
      sm="12"
      class=""
    >
      <button
        class="btn btn-danger btn-sm"
        @click="innerEditDefaultPickupDateTime = false"
      >
        Cancel Edit Default Pickup Date And Time {{ number }}
      </button>
    </b-col>
    <b-col
      v-if="defaultPickupDayText && defaultPickupTimeText && !innerEditDefaultPickupDateTime"
      cols="12"
      xl="4"
      lg="12"
      md="12"
      sm="12"
      class=""
    >
      <label>Last Saved Default Pickup Date And Time {{ number }}</label>
      <h6>{{ defaultPickupDayText + ' ' + defaultPickupTimeText }}</h6>
      <button
        class="btn btn-primary"
        @click="innerEditDefaultPickupDateTime = true"
      >
        Edit
      </button>
    </b-col>
    <b-col
      v-if="!defaultPickupDayText && !defaultPickupTimeText && !innerEditDefaultPickupDateTime"
      cols="12"
      xl="4"
      lg="12"
      md="12"
      sm="12"
      class=""
    >
      <button
        class="btn btn-primary btn-sm"
        @click="innerEditDefaultPickupDateTime = true"
      >
        Add Default Pickup Date And Time {{ number }}
      </button>
    </b-col>
  </b-row>
</template>
<script>
import { BCol, BRow } from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ref, watch } from '@vue/composition-api'

export default {
  components: { BCol, BRow, vSelect },
  // eslint-disable-next-line vue/require-prop-types
  props: ['number', 'editDefaultPickupDateTime', 'defaultPickupDayText', 'defaultPickupTimeText', 'defaultPickupDay', 'pickupDays', 'defaultPickupTime', 'pickupHours'],
  emits: ['editDefaultPickupDateTimeChange', 'defaultPickupDayChange', 'defaultPickupTimeChange'],
  setup(props, { emit }) {
    const innerDefaultPickupDay = ref(null)
    const innerDefaultPickupTime = ref(null)
    const innerEditDefaultPickupDateTime = ref(false)

    watch(innerEditDefaultPickupDateTime, val => {
      emit('editDefaultPickupDateTimeChange', val)
    })

    watch(innerDefaultPickupDay, val => {
      emit('defaultPickupDayChange', val)
    })

    watch(innerDefaultPickupTime, val => {
      emit('defaultPickupTimeChange', val)
    })

    return {
      innerDefaultPickupDay,
      innerDefaultPickupTime,
      innerEditDefaultPickupDateTime,
    }
  },
}
</script>
